import styled from 'styled-components'
import { STYLES } from '../../static/style'

const StyledToolbar = styled.div`
  display: flex;
  width: 100%;
  padding: 0.25rem ${STYLES.GUTTER};
  box-sizing: border-box;
  border-bottom: 1px solid ${STYLES.BORDER_COLOR};
`

export { StyledToolbar as Toolbar }
